var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app-container--width-max"},[_c('TenantsHeader',{on:{"openDrawer":_vm.openDrawer}}),_c('DrawerWhyChooseUs',{on:{"closeWhyChooseUsDrawer":_vm.closeDrawer},model:{value:(_vm.isDrawerOpen),callback:function ($$v) {_vm.isDrawerOpen=$$v},expression:"isDrawerOpen"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }